module.exports = __webpack_public_path__ + "fonts/intelo-bold.b7f9889.woff";